import cx from 'classnames';
import React from 'react';
import { Heading } from 'sly/system';
import { HeadingLevels } from 'sly/system/Heading/Heading.types';

export interface MarketingPageTitleProps {
  title: string;
  className?: string;
  mb?: string;
  font?: keyof typeof HeadingLevels;
}

const MarketingPageTitle = ({
  title,
  className,
  ...props
}: MarketingPageTitleProps) => (
  <>
    <Heading
      {...props}
      className={cx('font-t-l mb-xxl mr-l lg:w-[20.5rem]', className)}
      data-tp-id='gen-Heading-46e4291a-c20c-45cd-8220-b383045c8ee1'
    >
      {title}
    </Heading>
  </>
);

export default MarketingPageTitle;
